// Module
var code = "<md-button class=\"routes-loading-filters-panel\" ng-click=\"$ctrl.onShowPanel($event)\"> <md-icon md-svg-icon=\"filter\" aria-label=\"Filters\" class=\"filter-icon\"></md-icon> <md-tooltip>{{'Filters' | translate}}</md-tooltip> </md-button> ";
// Exports
export default code;